























































































































import Vue from 'vue';
import tableComponent from '@/components/TheTable.vue';
import cardInfoComponent from '@/components/TheCardInfo.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {
  requestUploadFinStatFile,
  requestUploadCompanyAccount,
  requestUploadBankCompanyAccount
} from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import { getTransactionsHistory } from '@/helpers/transaction';
import transactionPdfMaker from '@/helpers/pdfmakers/transaction';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;

@Component({
  name: 'FinancialPage',
  components: {
    SidebarRight,
    tableComponent,
    cardInfoComponent,
    titlePageComponent,
    PulseLoader
  }
})
export default class FinancialPage extends Base {
  btnText = 'Upload file';
  finStatTable = {
    titleText: 'FINANCIAL STATEMENTS',
    titleBg: 'pink-green-title',
    columns: [
      { field: 'id', title: '#' },
      { field: 'title', title: 'TITLE' },
      { field: 'creator', title: 'BY' },
      { field: 'date', title: 'UPLOADED' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  assetsTable = {
    titleText: 'OTHER ASSETS',
    titleBg: 'orange-title',
    sorted: 'counter',
    columns: [
      { field: 'counter', title: '#' },
      { field: 'companyName', title: 'COMPANY NAME' },
      { field: 'totalShares', title: 'TOTAL SHARES' },
      { field: 'sharesOwned', title: 'SHARES OWNED' },
      { field: 'percentOwned', title: '% OWNED' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  transectionsTable = {
    titleText: 'TRANSACTIONS',
    titleBg: 'green-blue-title',
    columns: [
      { field: 'id', title: '#' },
      { field: 'address', title: 'FROM/TO' },
      { field: 'direction', title: 'IN/OUT' },
      { field: 'amount', title: 'AMOUNT' },
      { field: 'date', title: 'DATE' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  history = [];
  isSyncAddress = false;
  isSyncAmount = false;

  // Computed
  get isUploadFilePending () {
    return this.getPendings.finStatement.update;
  }
  get isAgent () {
    return this.isReader;
  }
  get finStatData () {
    let rows: any[] = [];
    for (const variable in this.getFinStatements) {
      const row: any = {};
      const finStatement = this.getFinStatements[variable];
      if (!this.getMember(finStatement.address)) continue;
      row.id = finStatement.id;
      row.title = finStatement.title;
      row.creator = this.getMember(finStatement.address).name;
      row.date = this.$moment.unix(finStatement.creationTime).format(FORMAT_DATE);
      row.fileHash = finStatement.fileHash;
      row.name = finStatement.name;
      rows.push(row);
    }
    Vue.set(this.finStatTable, 'rows', rows);
    return this.finStatTable;
  }
  get assetsData () {
    let counter = 1;
    let rows: any[] = [];
    for (const variable in this.getOtherAssets) {
      const row: any = {};
      const otherAsset = this.getOtherAssets[variable];
      row.counter = counter++;
      row.id = variable;
      row.companyName = otherAsset.companyName;
      row.totalShares = otherAsset.totalSupply;
      row.sharesOwned = otherAsset.addrToken;
      let percent = ((row.sharesOwned / row.totalShares) * 100).toFixed(2);
      percent = percent === '0.00' && row.sharesOwned > 0 ? (percent = '0.01') : percent;
      percent =
        percent === '100.00' && row.sharesOwned < row.totalShares ? (percent = '99.99') : percent;

      row.percentOwned = percent + '%';
      row.companyURL = otherAsset.companyURL;
      rows.push(row);
    }
    Vue.set(this.assetsTable, 'rows', rows);
    return this.assetsTable;
  }
  get getTransactionsData () {
    Vue.set(this.transectionsTable, 'rows', this.history);
    return this.transectionsTable;
  }
  get ethAddress () {
    return parseInt(this.getCompanyEthereumWallet.address) === 0
      ? ''
      : this.getCompanyEthereumWallet.address;
  }
  get getInfoCards () {
    return [
      {
        id: 1,
        count: this.getCompanyBitcoinBalance,
        className: 'blue-bg',
        info: '//wallet ' + (this.getCompanyBitcoinWallet.address || ''),
        //@ts-ignore
        icon: require('@/assets/images/bitcoin-icon-2.svg'),
        edit: this.isOwner() && !this.isAgent,
        pending: this.getPendings.companyWalletBtc.update,
        type: 'BTC',
        address: this.getCompanyBitcoinWallet.address
      },
      {
        id: 2,
        count: this.ethAddress ? this.getCompanyEthereumBalance : '0',
        className: 'orange-bg',
        info: '//wallet ' + (this.ethAddress || ''),
        //@ts-ignore
        icon: require('@/assets/images/triangle-icon.svg'),
        edit: this.isOwner() && !this.isAgent,
        pending: this.getPendings.companyWalletEth.update,
        type: 'ETH',
        address: this.ethAddress
      },
      {
        id: 3,
        count: formatData.number(this.getCompanyBankWallet.value),
        className: 'green-bg',
        info: '//account at ' + (this.getCompanyBankWallet.name || ''),
        //@ts-ignore
        icon: require('@/assets/images/dollar-icon.svg'),
        edit: this.isOwner() && !this.isAgent,
        pending: this.getPendings.companyWalletBank.update,
        type: 'BANK'
      }
    ];
  }

  mounted(btcAddress: string | undefined, ethAddress: string | undefined) {
    this.getOtherAssetsExt();
    this.getTransactionsHistory(btcAddress, ethAddress);
  }

  // Methods
  downloadFinStatData (row) {
    this.ipfs.getFileByXHR(row.fileHash).then(blob => {
      this.downloadFile(blob, row.name);
    });
  }
  downloadTransectionsData (row) {
    const filename = 'transaction_#' + (row.id + 1);
    transactionPdfMaker(row, this.getMember, this.getOwners).download(filename);
  }
  visitCompany (row) {
    window.open(row.companyURL, '_blank');
  }
  requestUploadCompanyAccount (type) {
    if (type !== 'BANK') {
      this.setSideBarForm(requestUploadCompanyAccount(
        type,
        this.getTransactionsHistory.bind(this)
      ));
    } else {
      this.setSideBarForm(requestUploadBankCompanyAccount(
        this.getCompanyBankWallet,
        this.getTransactionsHistory.bind(this)
      ));
    }
    this.openClose();
  }
  requestUploadFile () {
    this.setSideBarForm(requestUploadFinStatFile());
    this.openClose();
  }
  downloadFile (blob, fileName) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
  getTransactionsHistory (btcAddress, ethAddress) {
    let bitCoinAddress = btcAddress || this.getCompanyBitcoinWallet.address;
    let ethereumAddress = ethAddress || this.ethAddress;
    getTransactionsHistory(bitCoinAddress, ethereumAddress)
      .then((history: any) => {
        this.history = history;
      })
      .catch(err => {
        console.error(err);
      });
  }
  syncAddressScroll (addressRef, amountRef) {
    if (!this.isSyncAddress) {
      this.isSyncAmount = true;
      amountRef.scrollTop = addressRef.scrollTop;
    }
    this.isSyncAddress = false;
  }
  syncAmountScroll (amountRef, addressRef) {
    if (!this.isSyncAmount) {
      this.isSyncAddress = true;
      addressRef.scrollTop = amountRef.scrollTop;
    }
    this.isSyncAmount = false;
  }
};
